import type { SVGProps } from 'react';
const SvgCrop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#crop_svg__a)">
      <path
        fill="currentColor"
        d="M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8ZM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7Z"
      />
    </g>
    <defs>
      <clipPath id="crop_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCrop;
